// extracted by mini-css-extract-plugin
export var container = "relatedlink-module--container--hCE23";
export var image = "relatedlink-module--image--MPxAJ";
export var text = "relatedlink-module--text--G2aUp";